import React from "react";
import { CaptionVariant, CaptionVariantCard } from "./CaptionVariantCard";

interface CaptionVariantsPanelProps {
  variants: CaptionVariant[];
  onSelect: (variantId: string) => void;
  onBack: () => void;
}

export const CaptionVariantsPanel: React.FC<CaptionVariantsPanelProps> = ({
  variants,
  onSelect,
  onBack,
}) => {
  return (
    <div className="caption-variants-panel">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-gray-900">
          Choose a caption
        </h3>
        <button
          onClick={onBack}
          className="px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded-sm hover:bg-gray-50 transition-colors"
        >
          ← Back to input
        </button>
      </div>

      <div className="grid grid-cols-1 gap-4">
        {variants.map((variant) => (
          <CaptionVariantCard
            key={variant.id}
            variant={variant}
            onSelect={() => onSelect(variant.id)}
          />
        ))}
      </div>
    </div>
  );
};
